import { ReactComponent as PassLock } from "@assets/SVG/lock.svg";
import { ReactComponent as MailIcon } from "@assets/SVG/mail.svg";
import { AuthenticationResult, EventType } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { useLocalStorage } from "@hooks/useLocalStorage";
import { useNotification } from "@hooks/useNotification";
import { Icon } from "@iconify/react";
import { loginRequest } from "@utils/azure-ad-sso";
import { getAllowedDomains } from "@utils/EmailUtils";
import { Button, Col, Divider, Form, Input, Modal, Row, Space, Typography } from "antd";
import axios from "axios";
import { Formik } from "formik";
import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { apiBaseUrl, post } from "~/Services/api.service";
import { reactAuthFlow } from "~/Utils";
import { defaultRedirectURL } from "~/Utils/StringConstants";
import acntDeactivated from "../../../Assets/PNG/deactivate_user.png";
import { ReactComponent as Microsoft } from "../../../Assets/SVG/microsoft.svg";
import { UserConsent } from "./UserConsent";
interface Props {
  authFlow: string;
}

export const SignInWithAzureAD = () => {
  const { instance } = useMsal();
  const location = useLocation();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const [isLoading, setIsLoading] = useState(false);
  const [user, setUser] = useLocalStorage("user", null);
  const [xAuthProvider, setxAuthProvider] = useLocalStorage("authProvider", "internal");
  const [openModal, setOpenModal] = useState(false);
  const [consentURL, setConsentURL] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [isSSOLoading, setIsSSOLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [response, setResponse] = useState<AuthenticationResult>();
  const [isError, setIsError] = useState<Boolean>(false);
  const [_, setCurrentModule] = useLocalStorage("currentModule", null);
  const allowedDomains = getAllowedDomains();

  const handleCloseModal = () => {
    localStorage.removeItem("user");
    instance.logout({ account: response?.account });
    window.location.pathname = "/auth/login";
  };

  const handleForgotPassword = () => {
    navigate("/auth/forgot-password");
  };

  const handleGetPasword = () => {
    navigate("/auth/get-password");
  };

  useEffect(() => {
    instance.addEventCallback((event: any) => {
      if (
        (event.eventType === EventType.LOGIN_SUCCESS || event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) &&
        event.payload
      ) {
        setIsSSOLoading(true);
        const response = event.payload as AuthenticationResult;
        setResponse(response);
        // const formData = new FormData();
        // formData.append("grant_type", "client_credentials");
        // formData.append("client_id", "5ab25ff4-f144-4328-8ed7-0fbf1638b423");
        // formData.append("client_secret", "xwv8Q~s1de.6nkmql~KUgQDDEhpeVFE1.ANRYaYd");
        // formData.append("scope", "api://a7eab610-891a-48f7-b233-c863a7bbc06b/.default");
        // axios.post(`https://login.microsoftonline.com/cb63c8b6-7cdf-44fb-8662-675bf9d1f979/oauth2/v2.0/token`, formData)
        // .then((res) => {
        //   console.log("responseesedfsd:", res.data);
        // })
        // .catch((err) => {
        //   console.error("Error:", err);
        // });
        axios
          .get(`${apiBaseUrl}/user/userprofile/access`, {
            headers: {
              Authorization: `Bearer ${response.accessToken}`,
              "X-Auth-Provider": "azure",
              "X-Auth-Type": "set-cookie",
            },
            withCredentials: true,
          })
          .then(({ data }: any) => {
            setxAuthProvider("azure");
            if (data.response && event.interactionType != "silent") {
              // Set role to SUPER_ADMIN if user has SUPER_ADMIN in access array, otherwise empty string
              const userAccess = data.response.data.access || [];
              const userRole = userAccess.includes("SUPER_ADMIN") ? "SUPER_ADMIN" : "";

              setUser({
                email: data.response.data.emailAddress,
                refreshToken: "",
                token: "",
                access: userAccess,
                role: userRole,
                isRequestedStatus: data.response.data.isUserOnboardApproved,
                status: data.response.data.status,
              });
              let access = data.response.data.access;
              let role: any = ""; //data.response.data.role;
              let requestStatus: any = data.response.data.isUserOnboardApproved;
              let isActive: any = data.response.data.isActive;

              // let access = ["MAGP_REVIEWER"];
              if (!access && isActive === false) {
                // window.location.pathname = defaultRedirectURL("WELCOME_PAGE");
                setIsModalVisible(true);
              } else if (!access && isActive === null) {
                window.location.pathname = defaultRedirectURL("WELCOME_PAGE");
              }
              // else if (access && access.length === 1 && access.includes("MAGP_REVIEWER")) {
              //   setCurrentModule("MAGP");
              //   window.location.pathname = defaultRedirectURL("MAGP_REVIEWER");
              // } else if (access && access.length === 1 && access.includes("MAGP_CREATOR")) {
              //   setCurrentModule("MAGP");
              //   window.location.pathname = defaultRedirectURL("MAGP_CREATOR");
              // }
              else if (role) {
                window.location.pathname = defaultRedirectURL("MODULE_SELECTION");
              }
              // else if (role && role !== Roles.SUPER_ADMIN) {
              //   window.location.pathname = defaultRedirectURL(role);
              // } else if (role && role === Roles.SUPER_ADMIN) {
              //   window.location.pathname = defaultRedirectURL("MODULE_SELECTION");
              // }
              else {
                window.location.pathname = defaultRedirectURL("WELCOME_PAGE");
              }
              setIsSSOLoading(false);
            }
          })
          .catch(() => {
            setIsSSOLoading(false);
            openToast({ content: "Something went wrong!", type: "error" });
            instance.logout({ account: response.account });
          });
      }
    });
  }, [instance]);

  const sendEmail = () => {
    // Cookie-based auth - no need to pass token in header
    axios
      .get(`${apiBaseUrl}/userprofile/consent-email/to-user`, {
        withCredentials: true,
        headers: {
          "X-Auth-Provider": "azure",
        },
      })
      .then(({ data }: any) => {});
  };

  const validationSchema = useMemo(() => {
    return Yup.object().shape({
      emailAddress: Yup.string()
        .email("Invalid email")
        .required("Email is required")
        .test("domain", `Email must end with ${allowedDomains.join(" or ")}`, (value) =>
          allowedDomains.some((domain) => value?.toLowerCase().endsWith(domain))
        ),
      password: Yup.string()
        .required("Password is required")
        .min(12, "Password must be at least 12 characters long")
        .matches(/[a-z]/, "Password must contain at least one lowercase letter")
        .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
        .matches(/[0-9]/, "Password must contain at least one number")
        .matches(/[^A-Za-z0-9]/, "Password must contain at least one special character"),
    });
  }, [allowedDomains]);

  const handleLogin = (values: any) => {
    const email = values?.emailAddress;
    setIsLoading(true);
    post("auth/login", values, { "X-Auth-Type": "manual" })
      .then((res: any) => {
        const message = res?.message;
        const mfaEnabled = res?.response?.data?.mfaEnabled;
        const firstTimeUser = res?.response?.data?.firstTimeUser;
        openToast({ content: message, type: "success" });
        navigate(`/auth/login/otp?emailAddress=${email}&mfa=${mfaEnabled}&api=true&firstTimeUser=${firstTimeUser}`);
      })
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <>
      <UserConsent
        active={isActive}
        openModal={openModal}
        consentURL={consentURL}
        setOpenModal={(val) => setOpenModal(val)}
      />
      {reactAuthFlow === "AZURE" && (
        <Button
          size="large"
          type="ghost"
          block
          onClick={() => {
            setIsLoading(true);
            instance.loginRedirect(loginRequest);
          }}
          loading={isLoading || isSSOLoading}
        >
          <Space
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Microsoft />
            <Typography.Text>Sign In With Active Directory</Typography.Text>
          </Space>
        </Button>
      )}
      {/* LOCALIZED LOGIN */}
      <Divider>
        <Typography.Text>Or</Typography.Text>
      </Divider>
      <Formik
        initialValues={{ emailAddress: "", password: "" }}
        validationSchema={validationSchema}
        onSubmit={(values) => {}}
      >
        {({ handleSubmit, handleChange, handleBlur, values, errors, touched, isValid, dirty }) => {
          return (
            <Form
              layout="vertical"
              onFinish={handleSubmit}
            >
              <Row style={{ marginBottom: "16px" }}>
                <Col span={24}>
                  <Form.Item
                    label="Email"
                    validateStatus={touched?.emailAddress && errors?.emailAddress ? "error" : ""}
                    help={touched?.emailAddress && errors?.emailAddress}
                  >
                    <Input
                      name="emailAddress"
                      prefix={<MailIcon />}
                      size="large"
                      placeholder="Enter your email id"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values?.emailAddress}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row style={{ marginBottom: "16px" }}>
                <Col span={24}>
                  <Form.Item
                    label="Password"
                    validateStatus={touched?.password && errors?.password ? "error" : ""}
                    help={touched?.password && errors?.password}
                  >
                    <Input.Password
                      name="password"
                      prefix={<PassLock />}
                      iconRender={(visible) =>
                        visible ? (
                          <Icon
                            icon="mdi:eye-outline"
                            width={18}
                            height={18}
                          />
                        ) : (
                          <Icon
                            icon="mdi:eye-off-outline"
                            width={18}
                            height={18}
                          />
                        )
                      }
                      size="large"
                      placeholder="Enter your password"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values?.password}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <Form.Item>
                    <Button
                      loading={isLoading}
                      disabled={!isValid || !dirty}
                      type="primary"
                      size="large"
                      block
                      htmlType="submit"
                      onClick={() => handleLogin(values)}
                    >
                      Sign In With Localized Login
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div>
                      <Typography.Link onClick={handleGetPasword}>First Time User?</Typography.Link>
                    </div>
                    <div>
                      <Typography.Link onClick={handleForgotPassword}>Forgot Password</Typography.Link>
                    </div>
                  </div>
                </Col>
              </Row>
            </Form>
          );
        }}
      </Formik>
      <Modal
        // title="Account Deactivation"
        visible={isModalVisible}
        onCancel={handleCloseModal}
        footer={[
          <Button
            key="close"
            type="primary"
            onClick={handleCloseModal}
          >
            Close
          </Button>,
        ]}
      >
        <div className="flex justify-center">
          <img
            src={acntDeactivated}
            alt="Account Deactivated"
            className="w-1/6 h-auto"
          />
        </div>
        <div className="mt-4 text-center">
          <p className="text-lg font-semibold text-red-600">Sorry, your account has been deactivated.</p>
          <p className="text-sm mt-2">Please contact your Admin for assistance.</p>
          <p className="text-sm font-semibold">
            <strong>Contact Details:</strong> ecms.support@malaysiaairports.com.my
          </p>
        </div>
      </Modal>
    </>
  );
};
